import { Edit } from '@mui/icons-material';
import { Box, Button, Card, FormControl, Grid, IconButton, MenuItem, Select, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { ChargesServices } from './services';
import Loading from '../../../../components/Loader/Loading';
import Swal from 'sweetalert2';

const formatValue = (value) => {
    if (!value && value !== 0) return '0'; // Return '0' for null, undefined, or empty, but not 0
    if (value === '0') return '0'; // Ensure '0' remains '0'
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return '0'; // Return '0' for non-numeric input

    // Remove leading zeros, but keep a single '0'
    const formattedValue = numValue.toString().replace(/^0+(?!\.|$)/, '');
    return formattedValue === '' ? '0' : formattedValue;
};

const Charges = () => {
    const [currentChargeDetails, setCurrentChargeDetails] = useState({
        platformFee: '',
        convenienceFeeType: 'percentage', //fixed
        convenienceFee: ''
    });
    const { control, handleSubmit, formState: { errors, isDirty }, watch, setValue, clearErrors, reset } = useForm({
        mode: 'onChange',
        defaultValues: currentChargeDetails
    });
    
    const [showChargeForm,setShowChargeForm] = useState(true);
    const [isLoading,setIsLoading] = useState(false);
    const [isSubmitting,setIsSubmitting] = useState(false);
    
    
    const convenienceFeeType = watch('convenienceFeeType');
    const submitChargeDetails = async (data) => {
        console.log("data:", data);
        if(currentChargeDetails.convenienceFee){
            const result = await Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, edit it!',
                allowOutsideClick: false
            });
            if (!result.isConfirmed) {
                return;
            }
                        
        }
        setIsSubmitting(true);
        // using swal processing dialog
        Swal.fire({
            title: 'Processing Data',
            text: 'Please wait while we processing Submission request...',
            icon: 'info',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        const response =await ChargesServices.addUpdateChargeDetails(data);
        console.log("response:",response);
        if(response.success == '1'){
            reset();
            fetchExistingCharges();
            await Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: response.message || `Charges Detail's Submitted successfully`,
                timer: 1500
            });
        }else if(response.success == '0'){
            await Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: response.message || `Charges Detail's Submission failed`
            })
        }
        setIsSubmitting(false);
    }
    const handleEdit = async() => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
            allowOutsideClick: false
        });
        if (result.isConfirmed) {
            setValue('platformFee', currentChargeDetails?.platformFee || '0', { shouldDirty: false,shouldValidate: true });
            setValue('convenienceFeeType', currentChargeDetails?.convenienceFeeType || 'percentage', { shouldDirty: false,shouldValidate: true });
            setValue('convenienceFee', currentChargeDetails?.convenienceFee || '0', { shouldDirty: false,shouldValidate: true })
            setShowChargeForm(true);
        }
        
    }
    
    const handleReset = () => {
        console.log("reset")
        reset({
            platformFee: '',
            convenienceFeeType: 'percentage',
            convenienceFee: ''
        });
        setShowChargeForm(false);
    }
    const fetchExistingCharges = async ()=>{
        setIsLoading(true);
        const response = await ChargesServices.fetchChargeDetails();
        console.log("response:",response);
        if(response.success == '1' && response.data.count=='1'){
            const data = response.data.rows[0];
            setCurrentChargeDetails({
                platformFee: data.platformFee,
                convenienceFeeType: data.convenienceFeeType,
                convenienceFee: data.convenienceFee
            })
            setShowChargeForm(false);
            setIsLoading(false);
        }else{
            setIsLoading(false);
        }
    }
    useEffect(()=>{
        fetchExistingCharges();
    },[]);
    useEffect(()=>{
        reset(currentChargeDetails)
    },[currentChargeDetails]);
    return (
        <Grid container spacing={1}>
            {isLoading && <Loading/>}
            {showChargeForm &&
                <Grid item xs={12}>
                    <Card>
                        <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                            <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }} >Charges Detail's</Typography>
                        </Box>

                        <Grid container spacing={1} component={'form'} onSubmit={handleSubmit(submitChargeDetails)} sx={{ p: 1 }}>
                            <Grid item xs={12} sm={6}>
                                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Platform Fee(₹) <span style={{ color: '#d32f2f' }}>*</span></Typography>
                                <Controller
                                    control={control}
                                    name='platformFee'
                                    rules={{
                                        required: 'Platform Fee required',
                                    }}
                                    render={({ field, fieldState: { error } }) =>
                                        <TextField
                                            {...field}
                                            size='small'
                                            fullWidth
                                            error={!!error}
                                            type='number'
                                            inputProps={{
                                                style: {
                                                    fontSize: '0.65rem'
                                                },
                                            }}
                                            onChange={(e) => {
                                                let inputValue = e.target.value;

                                                if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                                    // field.onChange(formatValue(inputValue));
                                                    let finalValue = formatValue(inputValue);

                                                    // Check if the value exceeds 10000 and constrain it
                                                    const numValue = parseFloat(finalValue);
                                                    if (!isNaN(numValue) && numValue > 9999) {
                                                        finalValue = '9999';
                                                    }

                                                    field.onChange(finalValue);
                                                }
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ display: { xs: 'none', sm: 'block' } }} />
                            <Grid item xs={12} sm={4}>
                                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Convenience Fee Type <span style={{ color: '#d32f2f' }}>*</span></Typography>
                                <Controller
                                    control={control}
                                    name="convenienceFeeType"
                                    rules={{
                                        required: 'select convenience fee type',
                                    }}
                                    render={({ field, fieldState: { error } }) => (
                                        <FormControl sx={{ minWidth: "100%" }} size="small">
                                            <Select
                                                {...field}
                                                error={!!error}
                                                sx={{
                                                    fontSize: '0.65rem',
                                                }}
                                            >
                                                <MenuItem value={'percentage'} sx={{ textTransform: 'capitalize', fontSize: '0.65rem' }}>Percentage</MenuItem>
                                                <MenuItem value={'fixed'} sx={{ textTransform: 'capitalize', fontSize: '0.65rem' }}>Fixed</MenuItem>
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem', color: !convenienceFeeType && 'lightGray' }}>Convenience Fee({convenienceFeeType === 'percentage' ? '%' : '₹'}) <span style={{ color: '#d32f2f' }}>*</span></Typography>
                                <Controller
                                    control={control}
                                    name='convenienceFee'
                                    rules={{
                                        required: 'Convenience Fee required',
                                    }}
                                    render={({ field, fieldState: { error } }) =>
                                        <TextField
                                            {...field}
                                            disabled={!convenienceFeeType}
                                            size='small'
                                            fullWidth
                                            error={!!error}
                                            type='number'
                                            inputProps={{
                                                style: {
                                                    fontSize: '0.65rem'
                                                },
                                            }}
                                            onChange={(e) => {
                                                let inputValue = e.target.value;

                                                if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {
                                                    // field.onChange(formatValue(inputValue));
                                                    let finalValue = formatValue(inputValue);

                                                    // Check if the value exceeds 10000 and constrain it
                                                    const numValue = parseFloat(finalValue);
                                                    if (!isNaN(numValue) && numValue > 9999) {
                                                        finalValue = '9999';
                                                    }

                                                    field.onChange(finalValue);
                                                }
                                            }}
                                        />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                                <Button size='small' variant='contained' sx={{ textTransform: 'capitalize' }} color='error' onClick={() => handleReset()}>Cancel</Button>
                                <Button size='small' variant='contained' sx={{ textTransform: 'capitalize' }} type='submit' disabled={!isDirty || isSubmitting}>Save</Button>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            }
            {currentChargeDetails?.convenienceFee &&
                <Grid item xs={12}>
                    <Card>
                        <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
                            <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }} >Current Charges Detail's</Typography>
                        </Box>

                        <Grid container spacing={1} sx={{ p: 1 }}>
                            <Grid item xs={5.5}>
                                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Platform Fee (₹)</Typography>
                                <TextField
                                    value={currentChargeDetails?.platformFee || ''}
                                    size='small'
                                    fullWidth
                                    type='number'
                                    inputProps={{
                                        style: {
                                            fontSize: '0.65rem'
                                        },
                                    }}
                                    disabled
                                />
                            </Grid>

                            <Grid item xs={5.5}>
                                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Convenience Fee ({currentChargeDetails?.convenienceFeeType === 'percentage' ? '%' : '₹'})</Typography>
                                <TextField
                                    value={currentChargeDetails?.convenienceFee || ''}
                                    size='small'
                                    fullWidth
                                    type='number'
                                    inputProps={{
                                        style: {
                                            fontSize: '0.65rem'
                                        },
                                    }}
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={1} sx={{ display: 'flex', alignItems: 'end' }}>
                                {!showChargeForm && <IconButton size='small' onClick={() => handleEdit()} color='warning' ><Edit /></IconButton>}
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
            }
        </Grid>
    )
}

export default Charges